import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "gatsby-theme-wirehead-bulma/src/layout"
import SEO from "gatsby-theme-wirehead-bulma/src/seo"
import { MDXRenderer } from "gatsby-plugin-mdx"

export default function PageTemplate({ data, location, pageContext }) {
  const { mdx } = data // data.markdownRemark holds your post data
  const { body } = mdx

  return (
    <Layout posted={pageContext.date} updated={pageContext.updated}>
      <SEO
        title={pageContext.title}
        pathname={location.pathname}
        description={pageContext.excerpt} />
    <section className="section">
    <Link to={mdx.frontmatter.url}><h1 className="title">&#x1F517;{pageContext.title}</h1></Link>
    <MDXRenderer>{body}</MDXRenderer>
    <Link to={mdx.frontmatter.url}>Link</Link>
    </section>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($id: String) {
    mdx(id: { eq: $id }) {
      body
      id
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        type
        description
        url
      }
      excerpt
    }
  }
`
